import type { TaxBracket, TaxRebate, TaxThresholds, TaxYear } from '../../../types/tax';
import { BaseTaxYearStrategy } from '../TaxYearStrategy';
import {
  TAX_BRACKETS_2026_27,
  TAX_REBATES_2026_27,
  TAX_THRESHOLDS_2026_27,
  ANNUAL_MEDICAL_AID_CREDITS_2026_27,
  TAX_YEAR_2026_27_START,
  TAX_YEAR_2026_27_END
} from '../../../data/tax';

export class TaxYear2026_27Strategy extends BaseTaxYearStrategy {
  getYear(): TaxYear {
    return '2026-27';
  }
  
  getDisplayName(): string {
    return '2026-2027 Tax Year (Current)';
  }
  
  getTaxBrackets(): TaxBracket[] {
    return TAX_BRACKETS_2026_27;
  }
  
  getTaxRebates(): TaxRebate {
    return TAX_REBATES_2026_27;
  }
  
  getTaxThresholds(): TaxThresholds {
    return TAX_THRESHOLDS_2026_27;
  }
  
  getMedicalAidCredits(): { mainMember: number; firstDependent: number; additionalDependent: number; } {
    return {
      mainMember: ANNUAL_MEDICAL_AID_CREDITS_2026_27.mainMember,
      firstDependent: ANNUAL_MEDICAL_AID_CREDITS_2026_27.firstDependent,
      additionalDependent: ANNUAL_MEDICAL_AID_CREDITS_2026_27.additionalDependent
    };
  }
  
  getStartDate(): Date {
    return TAX_YEAR_2026_27_START;
  }
  
  getEndDate(): Date {
    return TAX_YEAR_2026_27_END;
  }
}
